import { HttpLink } from '@apollo/client';
import { config } from '@config/config';

export type CreateHttpProps = {
  accessToken?: string;
};

export const createHttpLink = (props?: CreateHttpProps) => {
  const httpLink = new HttpLink({
    uri: config.API_GRAPHQL_ENDPOINT,
    ...(props?.accessToken
      ? {
        headers: {
          Authorization: `Bearer ${props.accessToken}`,
        },
      }
      : {}),
  });

  return httpLink;
};
